import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EmailRequest } from '../models/communications/email-request.model';

@Injectable()
export class EmailService {
  private baseUrl = 'api/email'

  constructor(private http: HttpClient) { }

  public sendEmail(emailRequest: EmailRequest): Observable<any> {
    return this.http.post<EmailRequest>(`${this.baseUrl}/send-to-many`, emailRequest)
      .pipe(catchError(this.handleBadRequest('Unable to send email(s)')));
  }

  handleBadRequest(genericMessage: string = 'An error occurred') {
    return (error: HttpErrorResponse) => {
      if (error.status >= 400 && error.status < 500 && typeof error.error === 'string') {
        return throwError(error.error);
      }
      return throwError(genericMessage);
    };
  }

}


